module.exports = __webpack_public_path__ + "static/media/hold-the-dark.4598cf8a.jpg";